import styled from "styled-components";
import { useState, useContext, useEffect, createContext } from "react";

interface DialogWindow {
    children: React.ReactNode;
    showEditWindow: boolean;
    header: string;
    setDialogProps: React.Dispatch<React.SetStateAction<DialogWindow>>;
  }
  
  export const DialogWindowContext = createContext<DialogWindow>({
    children: <></>,
    showEditWindow: false,
    header: "",
    setDialogProps: () => {},
  });

export default function DialogueWindowContextProvider(props: Props) {
    const [dialogProps, setDialogProps] = useState<DialogWindow>({
        children: <></>,
        showEditWindow: false,
        header: "",
        setDialogProps: () => {},
      });

  return (
    <DialogWindowContext.Provider value={{ ...dialogProps, setDialogProps }}>
      {props.children}
    </DialogWindowContext.Provider>
  );
}

interface Props {
  children: React.ReactNode;
}
